export default {
  data() {
    return {
      breadcrumb: [
        {
          text: this.$t('route.home'),
          to: this.localePath('/'),
        },
        {
          text: '',
        },
      ],
    }
  },

  beforeMount() {
    this.$nextTick(() => {
      this.initBreadCrumb()
    })
  },

  methods: {
    initBreadCrumb() {
      this.breadcrumb[1].text = this.product.name
    },
  },
}
